import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";
import { useGetSailInfoHeader } from "../hooks/useGetSailInfoHeader";

type SailInfoHeaderProps = {
    guid: string;
};

const SailInfoSailHeader: React.FC<SailInfoHeaderProps> = ({ guid }) => {
    const { data, isLoading } = useGetSailInfoHeader(guid);

    if (isLoading || !data) {
        return null;
    }

    return (
        <Card sx={{ width: "100%" }}>
            <CardHeader title="Sail Type" subheader={data.sailType} />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid size={6}>
                        <Typography variant="caption">Boat Type</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1">{data.boatType}</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="caption">Boat</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1">{data.boat}</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="caption">Order Number</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1">
                            {data.orderNumber}
                        </Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="caption">Designer</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1">{data.designer}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SailInfoSailHeader;
